import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'tareasOrdenPipe',
})
export class TareasOrdenPipe implements PipeTransform {

  transform(items: any[], filter: any[]): any {

    if (items) {

      if (filter['menu'] == 1) {
        return items.sort((a, b) => b[filter['orden']] - a[filter['orden']]);

      } else {

        return items.sort((a, b) => a[filter['orden']] - b[filter['orden']]);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pipes/tareas-orden/tareas-orden.ts